module.exports = __webpack_public_path__ + "img/img-2.485bf862.png";